import { useOrderStore } from 'modules/orders/store'
import { useLocation } from 'react-router-dom'
import { useIsFetching } from 'react-query'

/** Estado de loading do recálculo na duplicação (handler em DuplicateOrderRecalcHandler). */
export const useDuplicateOrderRecalcStatus = () => {
  const pageLocation = useLocation()
  const isDuplicatePage = pageLocation.pathname.includes('/duplicate')
  const isRecalculatingDuplicateOrder =
    useOrderStore.useIsRecalculatingDuplicateOrder()
  const isFetchingOrderProductsPrice = useIsFetching(['orderProductsPrice']) > 0

  return {
    isRecalculatingPrices:
      isDuplicatePage &&
      (isRecalculatingDuplicateOrder || isFetchingOrderProductsPrice)
  }
}
